"use strict"

angular.module("customer")
.service("OrderTemplateService", function($resource, $http, $filter, appConfig, FlashBag) {
    this.orderTemplateName = "";

    var orderTemplateResource = $resource(appConfig.API_SERVER + "/orders/templates/:id/", {id: "@id"}, {
        query: {
            method: "GET",
            isArray: false,
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        create: {
            method: "POST",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        update: {
            method: "PUT",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        get: {
            method: "GET",
            isArray: false,
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        delete: {
            method: "DELETE",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });
    var standingOrderLogResource = $resource(appConfig.API_SERVER + "/orders/templates/:id/logs/", {id: "@id"}, {
        query: {
            method: "GET",
            isArray: false,
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    this.query = function(params) {
        return orderTemplateResource.query(params);
    };

    this.queryLogs = function(params) {
        return standingOrderLogResource.query(params);
    };

    this.create = function(data) {
        return orderTemplateResource.create(data);
    };

    this.update = function(data) {
        return orderTemplateResource.update(data);
    };

    this.get = function(id) {
        return orderTemplateResource.get({id: id});
    };

    this.delete = function(id) {
        return orderTemplateResource.delete({id: id}).$promise;
    };

    this.generateCartFromOrderTemplate = function(orderTemplateId) {
        return $http.post(appConfig.API_SERVER + "/orders/templates/generate-cart/", {id: orderTemplateId});
    };

    this.generateCartToModifyOrderTemplate = function(orderTemplateId) {
        return $http.post(appConfig.API_SERVER + "/orders/templates/modify/generate-cart/", {id: orderTemplateId});
    };

    this.generateCartWithOrderTemplateFromOrder = function(orderId) {
        return $http.post(appConfig.API_SERVER + "/orders/templates/order/generate-cart/", {order_id: orderId});
    };

    this.generateCartStandingOrderFromOrderTemplateFromOrder = function(orderTemplateId) {
        return $http.post(appConfig.API_SERVER + "/orders/templates/standing-order/generate-cart/", {id: orderTemplateId});
    };

    this.showMissingProductsWarning = function(missingProducts, warningMessage) {
        var productMessage = "";
        for (var i = 0; i < missingProducts.length; i++) {
            productMessage += "<li>" + $filter("localizedField")(missingProducts[i]['product_name']) + " (" + missingProducts[i]['product_code'] + ")</li>";
        }
        FlashBag.warning(warningMessage + "<ul class='margin-bottom-0'>" + productMessage + "</ul>", true, 0);
    };

    function getStandingOrderDeliveryWeekdays(filter, weekdays, selectedWeekdays, availableWeekdays) {
        var weekdayNames = [];
        if (!selectedWeekdays || !availableWeekdays) {
            return "";
        }
        angular.forEach($filter(filter)(weekdays, availableWeekdays), function(weekdayName, weekday) {
            if (selectedWeekdays.includes(weekday.toString())) {
                weekdayNames.push(weekdayName);
            }
        });
        return weekdayNames.join(", ");
    }

    this.getStandingOrderAvailableDeliveryWeekdays = function(weekdays, selectedWeekdays, availableWeekdays) {
        return getStandingOrderDeliveryWeekdays("availableWeekdaysFilter", weekdays, selectedWeekdays, availableWeekdays);
    };

    this.getStandingOrderUnavailableDeliveryWeekdays = function(weekdays, selectedWeekdays, availableWeekdays) {
        return getStandingOrderDeliveryWeekdays("unavailableWeekdaysFilter", weekdays, selectedWeekdays, availableWeekdays);
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/order-template/order-template.service.js
// module id = 970
// module chunks = 0